<template>
    <div class='clause'>
        <h3 class='text text-center'>{{protocol.title}}</h3>
        <p>{{protocol.abstraction}}</p>

        <div class='clause-section' v-for='(section, pindex) in protocol.protocols' :key='`protocol-${pindex}`'>
            <h4 class='text text-center'>{{section.title}}</h4>
            <div v-for='(clause, cindex) in section.clauses' :key='`clause-${cindex}`'>
                <h4>{{clause.subtitle}}</h4>
                <p v-if='clause.intro'>{{clause.intro}}</p>

                 <div v-if='clause.examples'>
                    <div v-for='(example, eindex) in clause.examples' :key='eindex'>
                        <p>
                            {{example.text}}
                            <br><br v-if='example.separate'/>
                        </p>
                        <div v-if='example.src'>
                            <img :src='example.src' class='clause-example'/>
                            &nbsp;&nbsp;
                            <span class='text text-small'>{{example.caption}}</span>
                        </div>
                    </div>
                </div>

                 <div v-if='clause.details'>
                    <div v-for='(detail, dindex) in clause.details' :key='`detail-${dindex}`'>
                        <p>
                            {{cindex + 1}}.{{dindex + 1}}
                            {{detail.text}}
                        </p>
                        <ol v-if='detail.subjects'>
                            <li v-for='(subject, sindex) in detail.subjects' :key='`subject-${sindex}`'>
                                {{subject}}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['protocol']
    }
</script>

